import React, {PropsWithChildren} from 'react';

import './SearchDropdown.scss';

interface ISearchItem2LineProps {
    title: string;
    subtitle: string;
}

export function SearchItem2Line({title, subtitle}: PropsWithChildren<ISearchItem2LineProps>) {
    return (
        <div className="searchItem2Line">
            <div className="searchItem2Line_title ellipsis">{title || (<>&nbsp;</>)}</div>
            <div className="searchItem2Line_subtitle ellipsis">{subtitle || <>&nbsp;</>}</div>
        </div>
    )
}